import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  icon: '🛠️',
  price: '€ 9',
  title: 'Schemi Elettrici Pronti',
  desc: 'Unifilari, funzionali e planimetrie pronti da distribuire ai tuoi allievi o da usare direttamente in cantiere.'
}, {
  num: '02',
  icon: '🧪',
  price: '€ 7',
  title: '50 Attività Tecniche di Laboratorio',
  desc: 'Esercitazioni pratiche "Apri e Insegna" con istruzioni passo-passo per ogni livello, da base ad avanzato.'
}, {
  num: '03',
  icon: '📝',
  price: '€ 9',
  title: 'Verifiche e Valutazioni Complete',
  desc: 'Esami, quiz rapidi e rubriche di valutazione allineate agli standard EQF 4-5. Pronti da somministrare.'
}, {
  num: '04',
  icon: '📅',
  price: '€ 7',
  title: 'Pianificazione Completa del Corso',
  desc: 'Cronogramma da 90 o 200 ore già strutturato con UDA, obiettivi, metodologie e strumenti per ogni lezione.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-34">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-35" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-37">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-38">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-39" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream leading-tight" data-id="element-40">
            4 Bonus in Omaggio
            <br data-id="element-41" />
            <span className="text-brand-gold" data-id="element-42">con il tuo Sistema</span>
          </h2>
          <p className="text-gray-400 text-sm mt-3 max-w-2xl" data-id="element-43">
            Valore totale dei bonus: <span className="line-through" data-id="element-44">€49</span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-45">| €0,00 OGGI</span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-46">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-7 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-47">
              <div className="flex items-center justify-between gap-3 mb-3" data-id="element-48">
                <div className="flex items-center gap-2" data-id="element-49">
                  <span className="text-2xl" data-id="element-50">{bonus.icon}</span>
                  <span className="text-xs font-black text-brand-orange uppercase tracking-wider" data-id="element-51">
                    Bonus {bonus.num}
                  </span>
                </div>
                <div className="bg-green-500/20 border border-green-500/40 text-green-400 text-[11px] font-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-52">
                  {bonus.price} — IN OMAGGIO
                </div>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-brand-gold mb-3 leading-tight" data-id="element-53">
                {bonus.title}
              </h3>
              <p className="text-gray-300 font-medium text-sm sm:text-base leading-relaxed" data-id="element-54">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center bg-brand-card border border-brand-gold/40 rounded-2xl p-5" data-id="element-55">
          <p className="text-sm text-gray-400 mb-1" data-id="element-56">Valore totale dei bonus</p>
          <p className="text-3xl font-black text-brand-gold" data-id="element-57">
            €49{' '}
            <span className="text-base text-brand-cream" data-id="element-58">INCLUSI GRATIS</span>
          </p>
        </div>
      </div>
    </section>;
}